/* eslint @typescript-eslint/camelcase: "off" */

import { actionCreatorFactory } from 'typescript-fsa';
import { asyncFactory } from 'typescript-fsa-redux-thunk';

import { Api } from '@api';

import { AppStat } from '@common/utils/AppStat';

import { IState, IIndividual, ILegalEntity } from '@interfaces';

import {
	IDmcaActionAddFilesPayload,
	IDmcaActionRemoveFilePayload,
	IDmcaActionSubmitPayload,
	IDmcaActionSubmitDonePayload,
	IDmcaActionSubmitErrorPayload,
	IDmcaActionUploadFilePayload,
	IDmcaActionUploadFileDonePayload,
	IDmcaActionUploadFileErrorPayload,
} from './types';

const actionCreator = actionCreatorFactory('Dmca');
const actionCreatorAsync = asyncFactory<IState>(actionCreator);

export const uploadFile = actionCreatorAsync<
	IDmcaActionUploadFilePayload,
	IDmcaActionUploadFileDonePayload,
	IDmcaActionUploadFileErrorPayload
>(
	'uploadFile',
	async ({ file: { data: file } }: IDmcaActionUploadFilePayload) => {
		AppStat.log.boom.uploadFileForBoomDmca();

		const response = await Api.dmca.uploadFile(file);

		return {
			id: response.data.file,
		};
	},
);

export const addFiles = actionCreator<IDmcaActionAddFilesPayload>('addFiles');

export const removeFile = actionCreator<IDmcaActionRemoveFilePayload>('removeFile');

export const submitDmca = actionCreatorAsync<
	IDmcaActionSubmitPayload,
	IDmcaActionSubmitDonePayload,
	IDmcaActionSubmitErrorPayload
>(
	'submitDmca',
	async (params: IDmcaActionSubmitPayload) => {
		const {
			description,
			confirmation,
			files,
			isOwnerIndividual,
			owner,
		} = params;

		let individual = {};
		let legalEntity = {};

		if (isOwnerIndividual) {
			individual = {
				person_name: (owner as IIndividual).fullName,
				passport: `${(owner as IIndividual).passportSeries} ${(owner as IIndividual).passportNumber}`,
				issue_date: (owner as IIndividual).passportIssueDate,
				issued_by: (owner as IIndividual).passportIssuePlace,
				phone: owner.phone,
				email: owner.email,
			};
		} else {
			legalEntity = {
				company: (owner as ILegalEntity).title,
				ogrn: (owner as ILegalEntity).ogrn,
				legal_address: (owner as ILegalEntity).legalAddress,
				address: (owner as ILegalEntity).realAddress,
				phone: owner.phone,
				email: owner.email,
				person_name: (owner as ILegalEntity).contactPersonFullName,
				person_position: (owner as ILegalEntity).contactPersonPosition,
			};
		}

		AppStat.log.boom.submitBoomDmca();

		const response = await Api.dmca.submit({
			file: files,
			text: description,
			documents: confirmation,
			owner_is_person: Number(isOwnerIndividual),
			...individual,
			...legalEntity,
		});

		return {
			ok: response.data.ok,
		};
	},
);
